import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";

@Component({
    template: `

  `,
    selector: 'app-historico-erro'
})
export class HistoricoErroComponent implements OnInit {

    constructor(public dialog: MatDialog) {
    }

    ngOnInit() {
    }

    openInfoDialog(erro: string) {
        this.dialog.open(HistoricoErroDialogComponent, {
            data: erro,
            width: '800px'
        });
    }
}

@Component({
    selector: 'historico-erro-modal',
    templateUrl: 'historico-erro-modal.html'
})
export class HistoricoErroDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: string) {
    }
}

